import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../environments/environment.prod';
import { Router } from '@angular/router';
import { MyDatePipe } from './../my-date.pipe';

declare var $: any;
declare var Noty: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ MyDatePipe ]
})

export class HomeComponent implements OnInit, AfterViewInit {
  isFavourite: boolean = false;
  isTrending: boolean = true;
  isRecommended: boolean = false;
  isFree: boolean = false;
  isNew: boolean = false;
  isEditor: boolean = false;
  isPending: boolean = false;
  isCompleted: boolean = false;
  isCompany: boolean = false;

  userTypeId: number = -1;
  userId: number = -1;
  imgPath: string = "";
  isNext: boolean = false;
  isShareMenu: boolean = false;
  moduleId: number = -1;
  type: string = "";
  isLink: boolean = true;
  shareUrl: string = "";
  arr = Array;
  companyId: number = -1;
  reminderSubscription: boolean;
  quesId: number = 0;
  clickEnabled: boolean = true;
  userName: string = "";
  themeData: any[] = [];
  isLoading: boolean = false;
  noStaticSlider: boolean = false;
  noMasterSlider: boolean = false;
  seeMoreRecommendedSm: boolean = false;
  seeMoreRecommendedLg: boolean = false;
  seeMoreTrendingSm: boolean = false;
  seeMoreTrendingLg: boolean = false;
  seeMoreEditorSm: boolean = false;
  seeMoreEditorLg: boolean = false;
  seeMoreNewSm: boolean = false;
  seeMoreNewLg: boolean = false;
  seeMoreFreeSm: boolean = false;
  seeMoreFreeLg: boolean = false;
  seeMoreFavouriteSm: boolean = false;
  seeMoreFavouriteLg: boolean = false;
  seeMorePendingSm: boolean = false;
  seeMorePendingLg: boolean = false;
  seeMoreCompletedSm: boolean = false;
  seeMoreCompletedLg: boolean = false;
  seeMoreCompanySm: boolean = false;
  seeMoreCompanyLg: boolean = false;
  seeMoreStaticSm: boolean = false;
  seeMoreStaticLg: boolean = false;
  seeMoreStaticSm0: boolean = false;
  seeMoreStaticLg0: boolean = false;
  seeMoreStaticSm1: boolean = false;
  seeMoreStaticLg1: boolean = false;
  seeMoreStaticSm2: boolean = false;
  seeMoreStaticLg2: boolean = false;
  seeMoreStaticSm3: boolean = false;
  seeMoreStaticLg3: boolean = false;
  seeMoreStaticSm4: boolean = false;
  seeMoreStaticLg4: boolean = false;
  seeMoreStaticSm5: boolean = false;
  seeMoreStaticLg5: boolean = false;
  seeMoreStaticSm6: boolean = false;
  seeMoreStaticLg6: boolean = false;
  seeMoreStaticSm7: boolean = false;
  seeMoreStaticLg7: boolean = false;
  seeMoreMasterSm: boolean = false;
  seeMoreMasterLg: boolean = false;
  freeTag: boolean = false;
  staticBoxdata: any[]=[];
  staticBoxdata0: any[]=[];
  staticBoxdata1: any[]=[];
  staticBoxdata2: any[]=[];
  staticBoxdata3: any[]=[];
  staticBoxdata4: any[]=[];
  staticBoxdata5: any[]=[];
  staticBoxdata6: any[]=[];
  staticBoxdata7: any[]=[];
  showStaticBox: boolean = true;
  showStaticBox0: boolean = true;
  showStaticBox1: boolean = true;
  showStaticBox2: boolean = true;
  showStaticBox3: boolean = true;
  showStaticBox4: boolean = true;
  showStaticBox5: boolean = true;
  showStaticBox6: boolean = true;
  showStaticBox7: boolean = true;
  showStaticBox8: boolean = true;
  staticthemeData: any[]=[];
  masterData: any[]=[];
  myRouterLink: any;  

  constructor(private service: DataService,
    private router: Router,
    public datePipe: MyDatePipe) {
  }

  ngOnInit() {
    sessionStorage.clear();
    localStorage.clear();
    this.imgPath = environment.imagePath;    

    //Amandeep Kaur on 22-12-2020

    this.getAllThemes();
    this.changeBox(-1);
    this.activeMasterSlider();
    this.GetMasterClass();
    //ends here---
    
  }

  
  stratgistLogin(pvarChoice){
  
    if(pvarChoice==0){
      sessionStorage.setItem("IsStratGistLogin","false");
    } else {
      sessionStorage.setItem("IsStratGistLogin","true");
    }
    //this.router.navigate(['/login']);
    
    this.service.storageSub.next('change');
  }

  //Amandeep Kaur on 22-12-2020

  changeBox(Index) {

    $('.list-inline-item').click(function() {
      $('.list-inline-item').removeClass('currentlyActive');
      $(this).addClass('currentlyActive');
    });
    setTimeout(() => {
      this.activeStaticSlider(Index);
    }, 150)
    if(Index == 0) {
      
      this.showStaticBox0 = true;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 1) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = true;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 2) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = true;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 3) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = true;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 4) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = true;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 5) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = true;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 6) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = true;
      this.showStaticBox7 = false;
      this.showStaticBox  = false;
    } else if (Index == 7) {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = true;
      this.showStaticBox  = false;
    } else {
      this.showStaticBox0 = false;
      this.showStaticBox1 = false;
      this.showStaticBox2 = false;
      this.showStaticBox3 = false;
      this.showStaticBox4 = false;
      this.showStaticBox5 = false;
      this.showStaticBox6 = false;
      this.showStaticBox7 = false;
      this.showStaticBox  = true;   
    }
  }

  //ends here---


  //Amandeep Kaur on 22-12-2020

  getAllThemes() {
    this.service.GetHomeTheme({ 'CompanyId': this.companyId })
    .subscribe(
      (result: any[]) => {
        if (result['Status'] == "Success") {
          this.themeData = result['ThemeData'];
          this.GetDashBoardModuleStatic('Trending',-1);
          setTimeout(() => {
            for(var i=0; i<this.themeData.length;i++) {
              // console.log(i)
              // this.themeData.push(result['ThemeData'][i])
              this.GetDashBoardModuleStatic(this.themeData[i].ThemeId,i);
            }
          }, 150)
          // console.log(this.themeData)
          // this.themeData = themes;
          // this.themeData.sort((a, b): any => {
          //   return b['MaxTotal'] - a['MaxTotal']
          // });
        }
      },
      (error:Error) => {
        console.log(error);
      }
    )
  }

  //ends here---


  //Amandeep Kaur on 22-12-2020

  GetDashBoardModuleStatic(pvarId,index) {
    let inputJson;
    if(pvarId == 'Trending') {
      inputJson = {
        "ThemeId": index,
        "Type": pvarId,
        "UserId": this.userId
      }
    } else {
      inputJson = {
        "ThemeId": pvarId,
        "Type": "",
        "UserId": this.userId
      }
    } 
    // console.log(inputJson);
    this.service.GetDashBoardModuleV3(inputJson).finally(() => {
      setTimeout(() => {
        this.activeStaticSlider(index);
        this.activeSlider();
      }, 150)
    })
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){      
          if(index == 0) {
            this.staticBoxdata0 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 1) {
            this.staticBoxdata1 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 2) {
            this.staticBoxdata2 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 3) {
            this.staticBoxdata3 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 4) {
            this.staticBoxdata4 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 5) {
            this.staticBoxdata5 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 6) {
            this.staticBoxdata6 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else if (index == 7) {
            this.staticBoxdata7 = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          } else {
            this.staticBoxdata = result['DashBoardData'];
            this.staticthemeData = result['DashBoardData'];
          }
        }
        else{
          this.service.alert(result['Message'],"error");
        }
      },
      (error:Error)=>{
       console.log(error);
      }
    )
  }

  //ends here---
  GetMasterClass() {
    let inputJson = {
      "ThemeId": 57,
      "Type": "",
      "UserId": this.userId
    }
    console.log(inputJson);
    this.service.MasterClass(inputJson).subscribe(
      (result:any[])=> {
        if(result['Status'] == "Success") {
          this.masterData = result['DashBoardData']
        } else {
          this.service.alert(result['Message'],"error");
        }
      },
      (error:Error)=> {
        console.log(error)
      }
    )
}
  ngAfterViewInit() {
    $(window).scrollTop(0);
    $('.cd-header').removeClass(' menu-is-open');
    $('.cd-header').css('backgroundColor', 'transparent');
    $('.cd-header').removeClass('is-fixed');

    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      if (scrollPos == 0)
        $('.cd-header').removeClass('is-fixed');
    })
    $(window).resize(() => {
      this.resizeHandler();
    });
  }

  resizeHandler(){
    this.activeStaticSlider(-1);
    this.activeSlider();
    this.activeMasterSlider();
  }

  showActiveModule(pvarChoice) {
    this.isFavourite = false;
    this.isTrending = false;
    this.isRecommended = false;
    this.isFree = false;
    this.isNew = false;
    this.isEditor = false;
    this.isPending = false;
    this.isCompleted = false;
    this.isCompany = false;
    if (pvarChoice == 0) {
      this.isFavourite = true;
      return "/all-modules/Favourite"

    }
    if (pvarChoice == 1) {
      this.isTrending = true;
      return "/all-modules/Trending"

    }

    if (pvarChoice == 2) {
      this.isRecommended = true;
      return "/all-modules/Recommended"

    }

    if (pvarChoice == 3) {
      this.isFree = true;
      return "/all-modules/Free"

    }

    if (pvarChoice == 4) {
      this.isNew = true;
      return "/all-modules/New"
    }

    if (pvarChoice == 5) {
      this.isEditor = true;
      return "/all-modules/Editor's Pick"
    }

    if (pvarChoice == 6) {
      this.isPending = true;
      return "/all-modules/Pending"
    }

    if (pvarChoice == 7) {
      this.isCompleted = true;
      return "/all-modules/Completed"
    }

    if (pvarChoice == 8) {
      this.isCompany = true;
      return "/all-modules/Company"

    }
  }
  activeSlider() {




    setTimeout(() => {
      // check for padding
      let widthScreen = $(window).width();



      if (widthScreen <= 1500 && widthScreen > 1024) {
       
        
        if(this.staticthemeData.length < 5) {
          this.noStaticSlider = true;
        }
        if(this.masterData.length < 5)  {
          this.noMasterSlider = true;
        }   
      }

      if (widthScreen <= 1650 && widthScreen >= 1501) {
       
        if(this.staticthemeData.length < 6) {
          this.noStaticSlider = true;
        }
        if(this.masterData.length < 6)  {
          this.noMasterSlider = true;
        } 
      }

      if (widthScreen <= 2200 && widthScreen >= 1651) {
      
        if(this.staticthemeData.length < 7) {
          this.noStaticSlider = true;
        }
        if(this.masterData.length < 7)  {
          this.noMasterSlider = true;
        } 
      }

      if (widthScreen <= 2600 && widthScreen >= 2201) {
      
        if(this.staticthemeData.length < 7) {
          this.noStaticSlider = true;
        }
        if(this.masterData.length < 7)  {
          this.noMasterSlider = true;
        } 
      }
    }, 2000)


  }
  activeMasterSlider() {
    var width = $(window).width();
    if (width <= 768) {
      if (this.masterData.length > 3) {
        this.seeMoreMasterSm = true;
      }
    }

    if (width > 768) {
      if (this.masterData.length > 5) {
        this.seeMoreMasterLg = true;
      }
    }

    // new modules
    var $carousel10 = $('.slider10');
    var settings10 = {
      dots: false,
      arrows: true,
      slide: '.slick-slideshow__slide',
      slidesToShow: 4,
      centerMode: true,
      centerPadding: '20px',
      infinite: false,
      draggable: false,
      swipeToSlide: false,
      initialSlide: 0,
      touchMove: false,
      nextArrow: '<i class="fa fa-chevron-circle-right  arrow-right fa-3x" id="free-right-master"></i>',
      prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: true,
            initialSlide: 0,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: true,
            initialSlide: 0,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1100,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1500,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 4
          }
        },

        {
          breakpoint: 1650,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 5
          }

        },

        {
          breakpoint: 2200,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 6
          }
        },
        {
          breakpoint: 2600,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-master"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-master"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 8
          }
        }
      ]
    };

    if ($(window).width() > 768) {
      if (!$carousel10.hasClass('slick-initialized')) {

        $carousel10.slick(settings10);
      }
      // if(this.masterData.length <= 4){
      //
      //   if($carousel4.hasClass('slick-initialized')) {
      //   $carousel4.slick('unslick');
      // }
      // }
    }
    if ($(window).width() <= 768) {
      if (this.masterData.length > 1) {
        if (!$carousel10.hasClass('slick-initialized')) {
          $carousel10.slick(settings10);
        }
      }
    }
    // this.setSlideVisibility($carousel);

    $('#free-left-master').css('display', 'none')
    $carousel10.on('afterChange', function (slide, index) {

      // console.log(index.currentSlide);

      if (index.options.slidesToShow == 1) {
        var count = index.slideCount - index.options.slidesToShow;

        if (index.currentSlide === 1) {
          $('#free-left-master').css('display', 'block')
        }
        if (index.currentSlide === 0) {
          $('#free-left-master').css('display', 'none')
        }
        if (index.currentSlide === count) {
          $('#free-right-master').css('display', 'none')
        }

        else {
          $('#free-right-master').css('display', 'block')
          if (index.currentSlide > 1) {

          }
          if (index.currentSlide == 1) {

          }
        }
      } else {

        var count = index.slideCount - index.options.slidesToShow;
        // console.log(count);
        if (index.currentSlide === 1) {
          $('#free-left-master').css('display', 'block')
        }
        if (index.currentSlide === 0) {
          $('#free-left-master').css('display', 'none')
        }
        if (index.currentSlide === count) {
          $('#free-right-master').css('display', 'none')
        }

        else {
          $('#free-right-master').css('display', 'block')
          if (index.currentSlide > 1) {
            //$(".slider").css('padding-left',"25px");
          }
          if (index.currentSlide == 1) {
            //$(".slider").css('padding-left',"15px");
          }
        }
      }
    });
  }

  // activeSlider() {

  //   setTimeout(() => {
  //     // check for padding
  //     let widthScreen = $(window).width();

  //     if (widthScreen <= 1500 && widthScreen > 1024) {
      
  //       if(this.staticthemeData.length < 5) {
  //         this.noStaticSlider = true;
  //       }
       
  //     }

  //     if (widthScreen <= 1650 && widthScreen >= 1501) {
       
  //       if(this.staticthemeData.length < 6) {
  //         this.noStaticSlider = true;
  //       }
       
  //     }

  //     if (widthScreen <= 2200 && widthScreen >= 1651) {
      
  //       if(this.staticthemeData.length < 7) {
  //         this.noStaticSlider = true;
  //       }
       
  //     }

  //     if (widthScreen <= 2600 && widthScreen >= 2201) {
       
  //       if(this.staticthemeData.length < 7) {
  //         this.noStaticSlider = true;
  //       }
       
  //     }
  //   }, 2000)

  // }

  setSlideVisibility(carousel) {
    //Find the visible slides i.e. where aria-hidden="false"
    var visibleSlides = carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
    //Make sure all of the visible slides have an opacity of 1
    $(visibleSlides).each(function () {
      $(this).css('opacity', 1);
    });

    //Set the opacity of the first and last partial slides.
    //$(visibleSlides).first().prev().css('opacity', 0);
  }
  
  getNumber(rating) {
    return Math.round(rating);
  }
  
  hideShareOptions(pvarId) {
    if (this.moduleId == pvarId)
      this.isShareMenu = false;
  }

  activeStaticSlider(idx) {
console.log("ddd"+idx)
    if(idx != -1) {
      this.myRouterLink = '/module-by-theme/' + this.themeData[idx].Name + '/' + this.themeData[idx].ThemeId
    }    

    var width = $(window).width();
    if (width <= 768) {
      if (this.staticBoxdata.length > 3 && idx == -1) {
        this.seeMoreStaticSm = true;
      }     
      if(this.staticBoxdata0.length > 3 && idx == 0) {
        this.seeMoreStaticSm0 = true;
      }
      if(this.staticBoxdata1.length > 3 && idx == 1) {
        this.seeMoreStaticSm1 = true;
      }
      if(this.staticBoxdata2.length > 3 && idx == 2) {
        this.seeMoreStaticSm2 = true;        
      }
      if(this.staticBoxdata3.length > 3 && idx == 3) {
        this.seeMoreStaticSm3 = true;
      }
      if(this.staticBoxdata4.length > 3 && idx == 4) {
        this.seeMoreStaticSm4 = true;
      }
      if(this.staticBoxdata5.length > 3 && idx == 5) {
        this.seeMoreStaticSm5 = true;
      }
      if(this.staticBoxdata6.length > 3 && idx == 6) {
        this.seeMoreStaticSm6 = true;
      }
      if(this.staticBoxdata7.length > 3 && idx == 7) {
        this.seeMoreStaticSm7 = true;
      }
    }

    if (width > 768) {
      if (this.staticBoxdata.length > 5 && idx == -1) {
        this.seeMoreStaticLg = true;
      } 
      if (this.staticBoxdata0.length > 5 && idx == 0) {
        this.seeMoreStaticLg0 = true;
      }
      if (this.staticBoxdata1.length > 5 && idx == 1) {
        this.seeMoreStaticLg1 = true;
      }
      if (this.staticBoxdata2.length > 5 && idx == 2) {
        this.seeMoreStaticLg2 = true;
      }
      if (this.staticBoxdata3.length > 5 && idx == 3) {
        this.seeMoreStaticLg3 = true;
      }
      if (this.staticBoxdata4.length > 5 && idx == 4) {
        this.seeMoreStaticLg4 = true;
      }
      if (this.staticBoxdata5.length > 5 && idx == 5) {
        this.seeMoreStaticLg5 = true;
      }
      if (this.staticBoxdata6.length > 5 && idx == 6) {
        this.seeMoreStaticLg6 = true;
      }
      if (this.staticBoxdata7.length > 5 && idx == 7) {
        this.seeMoreStaticLg7 = true;
      }
    }

  
    // company modules
    if(idx == -1) {
      var $carousel9 = $('.slider9');
    } else if (idx == 0) {
      var $carousel9 = $('.slider90');
    } else if (idx == 1) {
      var $carousel9 = $('.slider91');
    } else if (idx == 2) {
      var $carousel9 = $('.slider92');
    } else if (idx == 3) {
      var $carousel9 = $('.slider93');
    } else if (idx == 4) {
      var $carousel9 = $('.slider94');
    } else if (idx == 5) {
      var $carousel9 = $('.slider95');
    } else if (idx == 6) {
      var $carousel9 = $('.slider96');
    } else if (idx == 7) {
      var $carousel9 = $('.slider97');
    } 

    var settings9 = {
      dots: false,
      arrows: true,
      slide: '.slick-slideshow__slide',
      slidesToShow: 4,
      centerMode: true,
      centerPadding: '20px',
      infinite: false,
      draggable: false,
      swipeToSlide: false,
      initialSlide: 0,
      touchMove: false,
      nextArrow: '<i class="fa fa-chevron-circle-right  arrow-right fa-3x" id="free-right-static"></i>',
      prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: true,
            initialSlide: 0,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 680,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 2,
            initialSlide: 0,
          }
        },
        {
          breakpoint: 500,
          settings: {
            arrows: true,
            initialSlide: 0,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '25px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1100,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1500,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 4
          }
        },

        {
          breakpoint: 1650,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 5
          }

        },

        {
          breakpoint: 2200,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 6
          }
        },

        {
          breakpoint: 2600,
          settings: {
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
            prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 8
          }
        },

      ]
    };

    if ($(window).width() > 768) {
      if (!$carousel9.hasClass('slick-initialized')) {
        $carousel9.slick(settings9);
      }
    }
    if ($(window).width() <= 768) {
      if (this.staticBoxdata.length > 1 && idx == -1) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata0.length > 1 && idx == 0) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata1.length > 1 && idx == 1) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata2.length > 1 && idx == 2) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata3.length > 1 && idx == 3) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata4.length > 1 && idx == 4) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata5.length > 1 && idx == 5) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata6.length > 1 && idx == 6) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      } else if (this.staticBoxdata7.length > 1 && idx == 7) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      }
    }
    // this.setSlideVisibility($carousel);

    $('#free-left-static').css('display', 'none')
    $carousel9.on('afterChange', function (slide, index) {

      // console.log(index.currentSlide);

      if (index.options.slidesToShow == 1) {
        var count = index.slideCount - index.options.slidesToShow;

        if (index.currentSlide === 1) {
          $('#free-left-static').css('display', 'block')
        }
        if (index.currentSlide === 0) {
          $('#free-left-static').css('display', 'none')
        }
        if (index.currentSlide === count) {
          $('#free-right-static').css('display', 'none')
        }

        else {
          $('#free-right-static').css('display', 'block')
          if (index.currentSlide > 1) {

          }
          if (index.currentSlide == 1) {

          }
        }
      } else {

        var count = index.slideCount - index.options.slidesToShow;
        // console.log(count);
        if (index.currentSlide === 1) {
          $('#free-left-static').css('display', 'block')
        }
        if (index.currentSlide === 0) {
          $('#free-left-static').css('display', 'none')
        }
        if (index.currentSlide === count) {
          $('#free-right-static').css('display', 'none')
        }

        else {
          $('#free-right-static').css('display', 'block')
          if (index.currentSlide > 1) {
            //$(".slider").css('padding-left',"25px");
          }
          if (index.currentSlide == 1) {
            //$(".slider").css('padding-left',"15px");
          }
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/home/home.component.ts